import { useEffect, useState } from 'react';
import fetcher, { MethodEnum } from 'utils/helpers/browser/newFetcher';

export interface MenuConfig {
    data: {
        is1Url?: string;
        is1RegistrationUrl?: string;
        financeUrl?: string;
        landingUrl?: string;
        clubQualityUrl?: string;
        is1HomeUrl?: string;
        is1CompetitionsUrl?: string;
    };
}

export function useMenuConfig() {
    const [is1Url, setIs1Url] = useState(null);
    const [is1RegistrationUrl, setIs1RegistrationUrl] = useState(null);
    const [financeUrl, setFinanceUrl] = useState(null);
    const [landingUrl, setLandingUrl] = useState(null);
    const [clubQualityUrl, setClubQualityUrl] = useState(null);
    const [is1HomeUrl, setIs1HomeUrl] = useState(null);
    const [is1CompetitionsUrl, setIs1CompetitionsUrl] = useState(null);

    function fetchData(): void {
        fetcher<MenuConfig>('/api/menu/config', MethodEnum.GET).then((e) => {
            setIs1Url(e.data.is1Url);
            setIs1RegistrationUrl(e.data.is1RegistrationUrl);
            setFinanceUrl(e.data.financeUrl);
            setLandingUrl(e.data.landingUrl);
            setClubQualityUrl(e.data.clubQualityUrl);
            setIs1HomeUrl(e.data.is1HomeUrl);
            setIs1CompetitionsUrl(e.data.is1CompetitionsUrl);
        });
    }

    useEffect(() => {
        fetchData();
    }, []);

    return {
        is1Url,
        is1RegistrationUrl,
        financeUrl,
        landingUrl,
        clubQualityUrl,
        is1HomeUrl,
        is1CompetitionsUrl,
    };
}
